import React from 'react';
import { getDeviceRagView } from '../../utils/deviceRagDisplay';
import './DeviceStatus.scss';

export default function DeviceStatusBadge({ device, className = '' }) {
  const view = getDeviceRagView(device);

  return (
    <div className={`device-status device-status-badge ${className}`.trim()}>
      <p className={view.badgeClass}>{view.label}</p>
    </div>
  );
}

export function DeviceConnectionText({ device }) {
  const view = getDeviceRagView(device);
  return <p className="ellipsis-text">{view.connectionText}</p>;
}
